export enum LoginStatus {
  LOGGED_IN,
  LOGGED_OUT,
  UNDEFINED,
}

export enum Privilage {
  ADMIN,
  USER,
}

export enum GraphType {
  LINE,
  BAR,
  PIE,
}

export enum ApiType {
  REST,
  SOAP,
  GRAPH_QL,
}
